var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-sm-flex d-none user-nav"},[_c('h2',{staticClass:"font-weight-bolder mb-0"},[_vm._v(" "+_vm._s(_vm.appTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }